module.exports = __webpack_public_path__ + "img/logo.fce05fa7.png";